import script from "./RegisterRequestList.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegisterRequestList.vue?vue&type=script&lang=ts&setup=true"

import "./RegisterRequestList.vue?vue&type=style&index=0&id=670b9d02&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-670b9d02"]])

export default __exports__